import React from "react";
import Input from "Components/UI/Input";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
const boolStatus = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const DeductionFrom = ({ mode = "I", onSubmit, show = false, handleClose }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
  } = useFormContext();
  console.log(errors);
  return (
    <Modal show={show} onHide={handleClose} animation={true} centered>
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>{mode === "I" ? "Add Deduction" : "Edit Deduction"}</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
          <div className="form-row">
            <div className="mb-3">
              <Input
                name="description"
                label="Deduction Name"
                placeholder="Deduction Name"
                className={`form-control ${
                  errors.description ? "is-invalid" : ""
                }`}
                labelClassName="form-label"
                type="text"
                required={true}
                requiredMessage="Deduction Name is requried"
              />
            </div>
            {/* <div className="mb-3">
              <Input
                name="haveCpf"
                type="commonSelect"
                placeholder="Have CPF"
                className={`form-control ${errors.haveCpf ? "is-invalid" : ""}`}
                label="Have CPF"
                labelClassName="form-label"
                optionData={boolStatus}
                required={true}
                requiredMessage="Have CPF is required"
                onChange={(selectedOption) => {
                  console.log(selectedOption);
                  setValue(
                    "haveCpf",
                    selectedOption
                  );
                  trigger("haveCpf");
                }}
                defaultValue={watch("haveCpf")}
                getPopupContainer={(trigger) => trigger.parentElement}
              />
            </div> */}

           
          </div>
          <div className="text-end mt-3">
            <button type="submit" className="btn btn-primary">
              {mode === "I" ? "Add" : "Update"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

DeductionFrom.propTypes = {
  mode: PropTypes.oneOf(["I", "E"]),
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default DeductionFrom;
